// date.js
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function str2Date(dateStr, separator) {
  if (!separator) {
    separator = '-'
  }
  const dateArr = dateStr.split(separator)
  const year = parseInt(dateArr[0])
  let month
  // 处理月份为04这样的情况
  if (dateArr[1].indexOf('0') == 0) {
    month = parseInt(dateArr[1].substring(1))
  } else {
    month = parseInt(dateArr[1])
  }
  const day = parseInt(dateArr[2])
  const date = new Date(year, month - 1, day)
  return date
}
export function formatTime(duration){
  if(!duration) return "00小时00分00秒";

    let day=parseInt(duration/(60*60*24))
    let h=parseInt((duration%(60*60*24))/(60*60))
    let m=parseInt((duration-h*60*60-day*(60*60*24))/60)
    let s=parseInt(duration%60);

    h=h.toString().length<2?"0"+h.toString():h.toString();
    m=m.toString().length<2?"0"+m.toString():m.toString();
    s=s.toString().length<2?"0"+s.toString():s.toString();

     if(parseInt(day)>0)
        return day.toString()+'天'+h+'小时'+m+'分';
       
      // return h+'小时'+m+'分';
      return  h+'小时'+m.toString()+'分'+s.toString()+'秒';
}